export default __webpack_public_path__ + "static/media/arrow-right.7895da26.svg";